import {Helper} from '../../../shared/classes';
import {FeatureEnum, PermissionsEnum} from '../../../shared/enums';

/**
 * Where the hard buying-power controls are offered, never on a wider gate than the backend's, because a 403 sends the whole app to /error.
 */
export class HardBuyingPowerRule {
    /** The set the backend's manage guard admits, minus the resource wildcard, which has no enum member. */
    private static readonly managePermissions: string[] = [
        PermissionsEnum.CrmHardBuyingPowerManage,
        PermissionsEnum.CrmAllAll
    ];

    /** The set the backend's group hard buying-power GET admits, wildcards included, which the add page's lookups need. */
    private static readonly viewGroupPermissions: string[] = [
        PermissionsEnum.CrmClientGroupsViewClientGroups,
        PermissionsEnum.CrmClientGroupsCreateNewGroup,
        PermissionsEnum.CrmClientGroupsUpdateGroup,
        PermissionsEnum.CrmClientGroupsAll,
        PermissionsEnum.CrmAllAll
    ];

    /** Both view-details rights, which the group workspace holds before it asks search-groups for account rows. */
    private static readonly viewAccountsPermissions: string[] = [
        PermissionsEnum.CrmTradingAccountsViewDetails,
        PermissionsEnum.CrmCashAccountsViewDetails
    ];

    static isFeatureOn(): boolean {
        return Helper.isFeatureEnabled(FeatureEnum.HardBuyingPower);
    }

    static canManage(userPermissions: string[]): boolean {
        return Helper.getUnionStrategyPermissionsCheck(HardBuyingPowerRule.managePermissions, userPermissions || []);
    }

    static isOffered(userPermissions: string[]): boolean {
        return HardBuyingPowerRule.isFeatureOn() && HardBuyingPowerRule.canManage(userPermissions);
    }

    static canViewGroup(userPermissions: string[]): boolean {
        return Helper.getUnionStrategyPermissionsCheck(HardBuyingPowerRule.viewGroupPermissions, userPermissions || []);
    }

    /** Trading (Hard BP) on the add page, whose group lookups would otherwise 403 and send the app to /error. */
    static isOfferedOnCreate(userPermissions: string[]): boolean {
        return HardBuyingPowerRule.isOffered(userPermissions) && HardBuyingPowerRule.canViewGroup(userPermissions);
    }

    /** Whether the add page may read a group's account rows for their currency, on the group workspace's own rule. */
    static canReadGroupAccounts(userPermissions: string[]): boolean {
        const permissions = userPermissions || [];

        return Helper.getUnionStrategyPermissionsCheck([PermissionsEnum.CrmAllAll], permissions)
            || Helper.getIntersectStrategyPermissionsCheck(HardBuyingPowerRule.viewAccountsPermissions, permissions);
    }
}
